export enum CalendarSyncLastViewMode {
  Day = 1,
  Week = 2,
  Month = 3,
}
